module.exports = __webpack_public_path__ + "img/marketing-4-voting.a093aaad.svg";